import { differenceInCalendarDays } from 'date-fns';

export type BatchExpiryStatus = 'expired' | 'expiring-soon' | 'ok' | 'unknown';

const EXPIRING_SOON_WITHIN_DAYS = 30;

// Shared across every place a batch's expiry is shown (list row breakdown,
// item detail Batches tab, purchase summary sidebar) so the "expiring soon"
// window stays consistent with the backend's own 30-day definition.
export function getBatchExpiryStatus(expiryDate: string | Date | null): BatchExpiryStatus {
  if (!expiryDate) {
    return 'unknown';
  }

  const daysToExpiry = differenceInCalendarDays(new Date(expiryDate), new Date());

  if (daysToExpiry < 0) {
    return 'expired';
  }
  if (daysToExpiry <= EXPIRING_SOON_WITHIN_DAYS) {
    return 'expiring-soon';
  }
  return 'ok';
}
